export default __webpack_public_path__ + "static/media/user-default.7e40f700.jpg";